class SortableItemUIModel<T> {
    public ItemId: string;
    public ItemIndex: number;
    public Model: T;

    public constructor(init?: Partial<SortableItemUIModel<T>>) {
        Object.assign(this, init);
    }
}

export { SortableItemUIModel };
